export const search_match = (term, array, key) => {
  const reg = new RegExp(term.split('').join('.*'), 'i');
  return array.filter((item) => item[key] && item[key].match(reg));
};
